import { GridColumnDataType } from '@infragistics/igniteui-angular';

import { GridColumnConfig } from './grid-column.config';

export class GridDateColumnConfig extends GridColumnConfig {
    format = 'shortDate';

    constructor(init?: Partial<GridDateColumnConfig>) {
        super(init);

        if (!!init) {
            Object.assign(this, init);
        }

        this.dataType = GridColumnDataType.Date;
    }
}
